import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Product, ReferenceCertificateAttribute, Res } from 'src/app/models';
import { ApiCertificatesService, DatetimeService, DialogModalService, FilesService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { DonwloadFileFromStorageComponent } from '../../files/donwload-file-from-storage/donwload-file-from-storage.component';
import { AttachingCertificateValidator } from './attaching-certificate.validator';

@Component({
  selector: 'app-attaching-certificate',
  templateUrl: './attaching-certificate.component.html',
  styleUrls: ['./attaching-certificate.component.css']
})


export class AttachingCertificateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  errorMessages: any;
  product_ids: string[] = [];
  certificateAttributes: ReferenceCertificateAttribute[];
  file: any;
  fileLink: string;
  type: 'create' | 'attach';
  certType: string;
  validToValue: string;
  currentDate = new Date();
  valueDateFrom = this.datetimeService.convertDateForDatepicker(Date());
  valueDateTo = this.datetimeService.convertDateForDatepicker(this.currentDate.setDate(this.currentDate.getDate() + 2));

  form: UntypedFormGroup = this.fb.group({
    attribute_id: [null, this.validator.attribute_id],
    file_id: [null, this.validator.file_id],
    valid_from: [null, this.validator.valid_from],
    valid_to: [null, this.validator.valid_to],
  });

  @Input() set data(value) {

    if (value != null) {

      this.product_ids = value.product_ids;
      this.type = value.type;
      this.certType = value.cert_type;

      if (this.certType) {
        this.form.controls.attribute_id.setValue(this.certType);
        this.form.controls.attribute_id.disable();
      }
    }
  }

  constructor(
    public ngProgress: NgProgress,
    public activeModal: NgbActiveModal,
    private dialogModal: DialogModalService,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private notification: NotificationService,
    private datetimeService: DatetimeService,
    private apiCertificates: ApiCertificatesService,
    private validator: AttachingCertificateValidator,
    private validatorService: ValidatorsService,
    private apiFileService: FilesService
  ) { }

  ngOnInit() {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.getCertificateAttributes();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
   * 
   * @param fieldName 
   * @param value 
   */
   eventFnDPVC(fieldName: string, value: any): void {

    console.log("DATE VALUE: ", value);
    

    this.form.controls[fieldName].setValue(this.datetimeService.convertDateForDatepicker(value));
    
  }

  /**
   * 
   */
  getCertificateAttributes(): void {

    let params = {
      filter: {}
    }

    this.subscriptions.add(
      this.apiCertificates.getReferences(params, 'certificate_attributes').subscribe((response: Res) => {
        console.log('[RESPONSE] getCertificateAttributes: ', response);

        if (response != null) {

          this.certificateAttributes = response.result;
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }


  /**
   * 
   * @param event 
   */
  uploadedFile(event): void {

    this.file = {
      id: event.result.id,
      name: event.result.name,
      url: event.result.link
    }

    this.form.controls.file_id.setValue(this.file.id);
    this.getImageContent(event.result.id);
  }


  /**
   * 
   */
  clearFile(): void {

    this.validToValue = null;
    this.file = null;
  }

  /**
  * @param i number
  * @param j number
  * @param attribute_id string
  */
  onUploadFileFromStorage(): void {

    let data = {};

    this.dialogModal.open(data, DonwloadFileFromStorageComponent).then(

      (result) => {
        
        if (result) {

          this.file = {
            id: result.id,
            name: result.name,
            url: result.link
          }
      
          if(result.date != null)  {this.validToValue = result.date;}
          this.form.controls.file_id.setValue(result.id);
          this.getImageContent(result.id);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   * @param index 
   * @param image 
   */
  getImageContent(file_id: any): void {

    this.fileLink = null;

    this.subscriptions.add(

      this.apiFileService.getImageContent(file_id).subscribe((response: any) => {
      

        if (response != null) {

          this.fileLink = response.result;
        }
      })
    );
  }


  /**
   * 
   */
  save(): void {

    let f: any = this.form.value;


    let params = {
      product_id: this.product_ids,
      certificate: {
        attribute_id: this.certType ? this.certType : f.attribute_id,
        file_id: f.file_id,
        valid_from: this.datetimeService.convertDateForDB(f.valid_from) + ' 00:00:00', // ! ВРЕМЕННОЕ РЕШЕНИЕ, ТРЕБУЕТСЯ DATETIME PICKER
        valid_to: this.datetimeService.convertDateForDB(f.valid_to) + ' 00:00:00'    // ! ВРЕМЕННОЕ РЕШЕНИЕ, ТРЕБУЕТСЯ DATETIME PICKER
      }
    }

    this.subscriptions.add(
      this.apiCertificates.save(params).subscribe((response: Res) => {
        console.log('[RESPONSE] saveCertificate: ', response);

        if (response != null) {

          this.notification.show('success', 'Сертификат успешно прикреплен!');
          this.activeModal.close(response.result);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   * @param fileName string
   * @returns string
   */
  checkIconExt(fileName: string): string {

    return this.apiFileService.checkIconExt(fileName);
  }

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }

}
